import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import EmployeeList from './pages/EmployeeList';
import ContentManager from './pages/ContentManager';
import LeadsViewer from './pages/LeadsViewer';
import Layout from './components/Layout';
import PublicLeadForm from './pages/PublicLeadForm';

import EmployeeLogin from './pages/EmployeeLogin';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Terms from './pages/Terms';
import EmployeeLayout from './components/EmployeeLayout';
import EmployeeHome from './pages/EmployeeHome';
import EmployeeTasks from './pages/EmployeeTasks';
import EmployeeCard from './pages/EmployeeCard';
import MyProfile from './pages/MyProfile';
import MyLeads from './pages/MyLeads';
import EmployeeRoute from './components/EmployeeRoute';
import AdminRoute from './components/AdminRoute';

import LandingPage from './pages/LandingPage';
import Microsite from './pages/Microsite';
import Tasks from './pages/Tasks';
import Visitors from './pages/Visitors';
import Reports from './pages/Reports';
import Campaigns from './pages/Campaigns';
import CampaignDetail from './pages/CampaignDetail';

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Routes - NO LAYOUT (No Sidebar/Header) */}
        <Route path="/login" element={<Login />} />
        <Route path="/employee/login" element={<EmployeeLogin />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/lead-form" element={<PublicLeadForm />} />
        <Route path="/profile/:slug" element={<LandingPage />} />
        <Route path="/microsite/:slug" element={<Microsite />} />

        {/* Employee Routes - Protected, WITH SIDEBAR (mirrors the admin layout) */}
        <Route path="/employee" element={<EmployeeRoute><EmployeeLayout /></EmployeeRoute>}>
          <Route index element={<Navigate to="/employee/home" replace />} />
          <Route path="dashboard" element={<Navigate to="/employee/home" replace />} />
          <Route path="home" element={<EmployeeHome />} />
          <Route path="leads" element={<MyLeads />} />
          <Route path="tasks" element={<EmployeeTasks />} />
          <Route path="performance" element={<Reports />} />
          <Route path="card" element={<EmployeeCard />} />
          <Route path="profile" element={<MyProfile />} />
        </Route>
        
        {/* Admin Routes - WITH LAYOUT (Sidebar + Header) */}
        <Route path="/" element={<AdminRoute><Layout /></AdminRoute>}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="tasks" element={<Tasks />} />
          <Route path="visitors" element={<Visitors />} />
          <Route path="reports" element={<Reports />} />
          <Route path="campaigns" element={<Campaigns />} />
          <Route path="campaigns/:id" element={<CampaignDetail />} />
          <Route path="employees" element={<EmployeeList />} />
          <Route path="content" element={<ContentManager />} />
          <Route path="leads" element={<LeadsViewer />} />
          <Route path="my-profile" element={<MyProfile />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
